import React, { useState } from "react";
import { FaCopy } from "react-icons/fa6";
import { Tooltip } from "react-tooltip";
import ChatbotComponent from "./ChatbotEmbed";

function DeployUIII({ userId, botId }) {
  const selectOption = [
    "bottomRight",
    "topRight",
    "bottomLeft",
    "topLeft",
    "middelLeft",
    "middelRight",
  ];
  const [select, setSelect] = useState("bottomRight");
  const [color, setColor] = useState("#002147");
  const [copysuccess, setCopysucess] = useState(false);

  const handleCopy = async () => {
    const text = document.getElementById("textcopy-2")?.textContent;
    try {
      await navigator.clipboard.writeText(text);
      setCopysucess(true);
      setTimeout(() => setCopysucess(false), 5000);
    } catch (err) {
      console.error("Failed to copy: ", err);
      setCopysucess(false);
    }
  };

  return (
    <div className="h-max flex-1 break-all flex flex-col text-white bg-gray-800 p-5 rounded-lg gap-5 shadow-lg 2xl:text-xl">
      <div>
        <h2 className="text-2xl 2xl:text-3xl font-bold tracking-wide">
          Instruction:
        </h2>
        <p className="text-lg 2xl:text-xl font-medium text-gray-300">
          Please add this script tag to the common header or footer tag of your
          HTML code to create a chatbot bubble at the bottom right corner of
          your website. If you do not have a common header or footer, please
          paste this on the pages where you wish to have the chatbot bubble.
        </p>
      </div>

      <div className="flex flex-wrap gap-4 2xl:text-xl">
        <div className="flex items-center gap-2">
          <span className="tracking-wider">Select Position:</span>
          <select
            className="rounded-lg bg-gray-700 px-3 py-2 text-white"
            value={select}
            onChange={(e) => setSelect(e.target.value)}>
            {selectOption.map((ele) => (
              <option value={ele} key={ele}>
                {ele}
              </option>
            ))}
          </select>
        </div>
        <div className="flex items-center gap-2">
          <label className="text-gray-300">Chat Bubble Color</label>
          <input
            type="color"
            value={color}
            onChange={(e) => setColor(e.target.value)}
            className="w-10 h-10 border border-gray-500 rounded"
          />
        </div>
      </div>

      <div className="relative w-full bg-gray-900 text-white p-5 gap-5 rounded-lg flex flex-col sm:flex-row justify-between items-center">
        <pre
          id="textcopy-2"
          className="overflow-auto w-full text-base 2xl:text-lg bg-gray-800 p-4 rounded-lg">
          {`<script>
            window.embeddedChatbotConfig = {
              chatbotId: '${botId}',
              userId: '${userId}',
              domain: '${process.env.REACT_APP_CLIENT_APP}',
              queryexpanstion: false,
              reranking: true,
              clor: '${color}',
              position: '${select}'
            };
          </script>

          <script src="${process.env.REACT_APP_CLIENT_APP}/chatbot-embedding.js"
           defer></script>`}
        </pre>
        <div className="absolute top-2 right-2">
          <button
            onClick={handleCopy}
            className="flex items-center gap-2 px-4 py-2 rounded-lg bg-gray-700 hover:bg-gray-600 transition text-white">
            <FaCopy className="w-5 h-5" />
            {copysuccess ? "Copied" : ""}
          </button>
          <Tooltip
            id="copy-tooltip"
            place="top"
            effect="solid"
            className="text-white bg-gray-700 p-2 rounded-md">
            Copy to clipboard
          </Tooltip>
        </div>
      </div>

      <ChatbotComponent
        botId={botId}
        userId={userId}
        select={select}
        color={color}
      />
    </div>
  );
}

export default DeployUIII;
